import { render } from "./ExploreMovies.vue?vue&type=template&id=2bf7428c&scoped=true"
import script from "./ExploreMovies.vue?vue&type=script&lang=js"
export * from "./ExploreMovies.vue?vue&type=script&lang=js"

import "./ExploreMovies.vue?vue&type=style&index=0&id=2bf7428c&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf7428c"]])

export default __exports__